import { UserState } from "../../../hooks/useUser";
import { updateVerification, Verification, VerificationUpdate } from "../../../networkRequest/officialsService";




export const updateOfficialVerification = async (user: UserState, updatedData: VerificationUpdate): Promise<Verification> => {
  const { data, error } = await updateVerification(user.accessToken, updatedData);

  if (error) {
    throw new Error(error);
  } else if (!data) {
    throw new Error('Error updating official verification.');
  }

  return data;
}